/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55967492
 */

import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import Icon from '@components/@core/Icon';

const CoreAccordion = ({ 
    className = '', 
    icon = 'fas fa-gear', 
    title = 'Filter Settings', 
    subTitle = null, 
    size = 'small', 
    type = 'primary', 
    expanded = false, 
    children, 
    onChange = () => {} 
}) => (
    <Accordion allowZeroExpanded className={cx('core-accordion', className, size, type)} preExpanded={expanded ? ['core-accordion-item'] : []} onChange={onChange}>
        <AccordionItem uuid="core-accordion-item">
            <AccordionItemHeading>
                {isValidElement(title) ? (
                    title
                ) : (
                    <AccordionItemButton>
                        <div className="d-h-start">
                            {icon && <Icon name={`${icon} me-2`} size={16} color="#c3c7cc" />}
                            <p className="dsl-b14 text-400 mb-0">{title}</p>
                            {subTitle}
                        </div>
                    </AccordionItemButton>
                )}
            </AccordionItemHeading>
            <AccordionItemPanel>{children}</AccordionItemPanel>
        </AccordionItem>
    </Accordion>
);

CoreAccordion.propTypes = {
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subTitle: PropTypes.node,
    icon: PropTypes.string,
    expanded: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'regular']),
    type: PropTypes.oneOf(['primary', 'secondary']),
    onChange: PropTypes.func,
};

export default CoreAccordion;
